<script setup>
import { computed, ref } from "vue";
import Button from "primevue/button";
import Menu from "primevue/menu";
import { storeToRefs } from "pinia";
import Dialog from 'primevue/dialog';

import { useGlobalToast } from '@/composables/useGlobalToast';
const { showToast } = useGlobalToast();

import { deletarQuestao, salvarQuestao } from "@/api/fetchQuestoes";
import { useRecursosDidaticosStore } from "@/store/recursosDidaticosStore";

import EditarQuestao from "@/components/professor/CriarQuestoes/EditarQuestao.vue";

const store = useRecursosDidaticosStore();
const { idUsuario, questoes } = storeToRefs(store);
const visible = ref(false);

const props = defineProps({
    questaoId: Number
})

const questao = computed(() => {
    return questoes.value.find(item => item.id === props.questaoId);
})

const menu = ref();

const opcoes = computed(() => {
    if (idUsuario.value !== questao.value.proprietario) {
        return [
            {
                label: 'Duplicar',
                icon: 'pi pi-clone',
                command: () => {
                    duplicar()
                }
            }
        ]
    };
    return [
        {
            label: 'Editar',
            icon: 'pi pi-pencil',
            command: () => {
                visible.value = true

            }
        },
        {
            label: 'Duplicar',
            icon: 'pi pi-clone',
            command: () => {
               duplicar()
            }
        },
        {
            label: 'Excluir',
            icon: 'pi pi-trash',
            command: async () => {
                await deletarQuestao(questao.value.id);
                questoes.value = questoes.value.filter(item => item.id !== questao.value.id)
            }
        }
    ]
})
const items = ref(opcoes);

const toggle = (event) => {
    menu.value.toggle(event);
};

async function duplicar() {
    let questaoCopiada = {...questao.value};
    delete questaoCopiada.id
    let result = await salvarQuestao(questaoCopiada);
    if (result.data) {
        questaoCopiada.id = result.data[0].id;
        questoes.value.unshift(questaoCopiada);
    } 
    
    showToast({ detail: 'A questão copiada foi adiciona ao início da lista' });
}
</script>

<template>
    <Dialog v-model:visible="visible" modal header="Editar" :style="{ width: '50vw' }"
        :breakpoints="{ '1199px': '75vw', '575px': '100vw' }">

        <EditarQuestao v-model:questao="questao" @update:visible="visible = $event" />

    </Dialog>
    <Button v-tooltip.top="'Gerenciar Questão'" type="button" icon="pi pi-ellipsis-v" @click="toggle"
        aria-haspopup="true" aria-controls="overlay_menu" severity="secondary" text="" />
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />

</template>
